import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SubstationTemplateService } from '../../../services/substation-template.service';
import { ConnectorSwitchService } from '../../../services/connector-switch.service';

@Component({
  selector: 'lib-nec-stats-by-template',
  templateUrl: './nec-stats-by-template.component.html',
  styleUrls: [
    './nec-stats-by-template.component.scss',
    '../network-entity-classes.component.scss',
  ],
  standalone: false,
})
export class NecStatsByTemplateComponent implements OnInit, OnChanges {
  @Input() selectedEquipment!: string;
  @Input() utilityId: number | null = null;

  constructor(
    private substationTemplateService: SubstationTemplateService,
    private connectorSwitchService: ConnectorSwitchService,
  ) {}

  statsByTemplate: {
    templateName: string;
    templateId: number;
    count: number;
  }[] = [];

  ngOnInit(): void {
    this.getEquipmentStatsByTemplate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedEquipment']) {
      this.loadEquipmentStatsForTemplates();
    }
  }

  getEquipmentStatsByTemplate() {
    this.substationTemplateService.getAll(this.utilityId ?? 0).subscribe({
      next: (response: any) => {
        const substationTemplates = response?.body?.data;
        this.statsByTemplate = substationTemplates.map((tmpl: any) => ({
          templateName: tmpl.className,
          templateId: tmpl.id,
          count: 0,
        }));
        this.loadEquipmentStatsForTemplates();
      },
    });
  }

  loadEquipmentStatsForTemplates() {
    this.statsByTemplate.forEach((sbt) => {
      this.connectorSwitchService
        .getEquipmentStatsByTemplate({
          equipmentType: this.selectedEquipment,
          templateDefinitionId: sbt.templateId,
        })
        .subscribe({
          next: (response: any) => {
            const data = response.body.data;
            sbt.count = data.count;
          },
        });
    });
  }
}
